import React, { FC, useEffect } from 'react'
import FullCalendar from '@fullcalendar/react'
import { useLocation } from 'react-router-dom'
import Loader from '../../loader/Loader'
import { IFullCalendarSection } from '../../../interfaces/ICommonComponents'

export const FullCalendarSection: FC<IFullCalendarSection> = ({
  calendarConfig,
  events,
  calendarRef,
  eventsPending = false,
  updateCalendarView,
}) => {
  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const viewParam = searchParams.get('view')

    if (viewParam && updateCalendarView) {
      updateCalendarView(viewParam)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className="relative">
      <FullCalendar
        {...calendarConfig}
        events={events as any}
        ref={calendarRef}
      />
      {eventsPending && (
        <div className="overlay backgroundNeutralLightestFade50 notAllowed">
          <Loader />
        </div>
      )}
    </div>
  )
}
